import moment from 'moment'
export default {
  install (Vue, options) {
    Vue.prototype.$formatter = {
      getRoundedNumberWithPrecision (num, decimalPlaces = 2) {
        var p = Math.pow(10, decimalPlaces)
        var n = (num * p) * (1 + Number.EPSILON)
        return Math.round(n) / p
      },
      replaceDotWithComma (value) {
        if (value === null || value === undefined || value === '') return ''
        if (value.toString().includes(',')) return value
        return this.getRoundedNumberWithPrecision(value).toFixed(2).toString().replace('.', ',')
      },
      replaceDotWithCommaWOFixed (value) {
        if (value === null || value === undefined || value === '') return ''
        return value.toString().replace('.', ',')
      },
      replaceDotWithCommaOneDigit (value) {
        if (value === null || value === undefined || value === '') return ''
        return parseFloat(value).toFixed(1).toString().replace('.', ',')
      },
      parseDate (date) {
        return moment(date, 'YYYY-MM-DD').isValid() ? moment(date, 'YYYY-MM-DD').format('DD.MM.YYYY') : null
      },
      thousandSeparator (value) {
        if (value === null || value === undefined || value === '') return ''
        const total = this.getRoundedNumberWithPrecision(value).toFixed(2).toString().replace('.', ',')
        return (total.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 '))
      },
      replaceDotWithCommaNotFixed (value) {
        if (value === null || value === undefined || value === '') return ''
        return Number(Math.floor(parseFloat(value))).toString()
      },
      replaceDotWithCommaIfHasDecimal (value) {
        if (value === null || value === undefined || value === '') return ''
        if (value.toString().includes(',')) return value
        return this.getRoundedNumberWithPrecision(value).toString().replace('.', ',')
      },
      replaceCommaWithDot (value) {
        if (!value) return null
        return value.toString().replace(',', '.')
      },
      absoluteNumber (value) {
        if (value === null || value === undefined || value === '') return '0'
        return value.toString().indexOf('.') === -1 ? parseFloat(value).toString() : this.getRoundedNumberWithPrecision(value).toFixed(2).toString().replace('.', ',')
      },
      replaceCommaWithDotCal (value) {
        if (!value) return 0
        return parseFloat(value.toString().replace(',', '.'))
      },
      cloneVariable (data) {
        if (!data) return null
        return JSON.parse(JSON.stringify(data))
      },
      filterDate (date) {
        if (!date) return null
        return moment(date, 'DD.MM.YYYY').isValid() ? moment(date, 'DD.MM.YYYY').format('DD.MM.YYYY') : null
      },
      getTotay () {
        return moment().format('YYYY-MM-DD')
      },
      getTodayInUserFormat () {
        return moment().format('DD.MM.YYYY')
      },
      formatDate (date, fromFormat, toFormat) {
        if (!date) return null
        return moment(date, fromFormat).isValid() ? moment(date, fromFormat).format(toFormat) : null
      },
      isNullOrEmpty (val) {
        return val === undefined || val === null || val === ''
      },
      isNull (val) {
        return val === null
      },
      isEmptyObject (obj) {
        return Object.entries(obj).length === 0 && obj.constructor === Object
      },
      isArrayHasData (array) {
        if (array && array.length > 0) return true
        else return false
      },
      debounce (func, delay) {
        let debounceTimer
        return function () {
          const context = this
          const args = arguments
          clearTimeout(debounceTimer)
          debounceTimer = setTimeout(() => func.apply(context, args), delay)
        }
      },
      groupBy (array, key) {
        return array.reduce(function (total, item) {
          total[item[key]] = total[item[key]] || []
          total[item[key]].push(item)
          return total
        }, {})
      },
      // Array format and parse number
      formatAndParseList (list, listOfValues, methodName) {
        if (list.length > 0) {
          const result = []
          list.forEach(element => {
            result.push(this.formatAndParseModel(element, listOfValues, methodName))
          })
          return result
        } else return []
      },
      // Object format and parse numbers
      formatAndParseModel (model, listOfValues, methodName) {
        const modelData = this.cloneVariable(model)
        listOfValues.forEach(element => {
          modelData[element] = parseFloat(this[methodName](modelData[element]))
        })
        return modelData
      },
      /* {
        number: { list:['qty', 'price'], format: 'replaceCommaWithDot' },
        date: { list:['start', 'end'], from: 'DD.MM.YYYY', to: 'YYYY.MM.DD'},
        status: { list:['status'], text: '', value: '$_ccsheetStatus' },
        merge: { list:['firstname', 'lastname'], property: 'username' }
      */
      formatModel (model, data) {
        model = JSON.parse(JSON.stringify(model))
        const keys = Object.keys(data)
        keys.forEach(key => {
          switch (key) {
            case 'number': {
              const formatObj = data.number
              formatObj.list.forEach(item => {
                model[item] = this[formatObj.format](model[item])
              })
              break
            }
            case 'date': {
              const formatObj = data.date
              formatObj.list.forEach(item => {
                if (model[item]) {
                  const dateObj = this.formatDate(model[item], formatObj.from, formatObj.to)
                  model[item] = dateObj
                }
              })
              break
            }
            case 'status': {
              const formatObj = data.status
              formatObj.forEach(item => {
                const statusArray = this[item.value]
                statusArray.map(function (x) {
                  if (x.value === model[item]) model[item] = { text: x.text, value: model[item] }
                })
              })
              break
            }
            default:
              break
          }
        })
        return model
      },
      // Set Foreground color based on the background color
      foreGroundColor (colorValue) {
        const rgbCode = colorValue ? this.hexToRgbA(colorValue) : ''
        const color = rgbCode ? rgbCode.toString().split('(')[1] : ''
        const resultOnColor = color.split(',', 3)
        const R = resultOnColor[0]
        const G = resultOnColor[1]
        const B = resultOnColor[2] ? resultOnColor[2].toString().replace(')', '') : 0
        const C = [R / 255, G / 255, B / 255]
        for (var i = 0; i < C.length; ++i) {
          if (C[i] <= 0.03928) {
            C[i] = C[i] / 12.92
          } else {
            C[i] = Math.pow((C[i] + 0.055) / 1.055, 2.4)
          }
        }
        const L = 0.2126 * C[0] + 0.7152 * C[1] + 0.0722 * C[2]
        if (L > 0.179) {
          return 'black'
        } else {
          return 'white'
        }
      },
      hexToRgbA (hex) {
        hex = hex.slice(0, -2)
        var c
        if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
          c = hex.substring(1).split('')
          if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]]
          }
          c = '0x' + c.join('')
          return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',1)'
        }
        return null
      },
      mimeTypeOfDocument (type) {
        let image = ''
        switch (type) {
          case 'image/png':
          case 'image/jpeg':
          case 'image/gif':
          case 'image/svg+xml':
            image = { icon: 'mdi-file-image', color: 'grey' }
            break
          case 'application/pdf':
            image = { icon: 'mdi-file-pdf-box', color: 'error' }
            break
          case 'text/html':
            image = { icon: 'mdi-language-html5', color: '#f16428' }
            break
          case 'video/mp4':
            image = { icon: 'mdi-file-video', color: 'grey' }
            break
          case 'audio/mpeg':
            image = { icon: 'mdi-audiobook', color: 'grey' }
            break
          case 'application/msword':
          case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          case 'application/vnd.openxmlformats-officedocument.wordprocessingml.template':
            image = { icon: 'mdi-file-word', color: 'info' }
            break
          case 'application/vnd.ms-excel':
          case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
          case 'application/vnd.openxmlformats-officedocument.spreadsheetml.template':
            image = { icon: 'mdi-file-excel', color: 'green' }
            break
          case 'application/vnd.ms-powerpoint':
          case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
          case 'application/vnd.openxmlformats-officedocument.presentationml.template':
          case 'application/vnd.openxmlformats-officedocument.presentationml.slideshow':
            image = { icon: 'mdi-file-powerpoint', color: 'error' }
            break
          case 'application/x-rar-compressed':
          case 'application/octet-stream':
          case 'application/zip':
          case 'application/x-zip-compressed':
          case 'multipart/x-zip':
            image = { icon: 'mdi-zip-box', color: 'grey' }
            break
          case 'folder':
            image = { icon: 'mdi-folder', color: '#ffda6b' }
            break
          default:
            image = { icon: 'mdi-file-cloud', color: 'grey' }
            break
        }
        return image
      },
      findWidthPixel () {
        return 200
      },
      conventToPositive (number) {
        return Math.abs((number))
      },
      optionsValuesDuplication (options) {
        let values = options.map(x => x.value)
        return values.some((x, i) => values.indexOf(x) !== i)
      },
      optionsLabelDuplication (options) {
        let labels = options.map(x => x.label)
        return labels.some((x, i) => labels.indexOf(x) !== i)
      }
    }
  }
}
